import React from 'react'

import { Section, Container, Row, Column } from 'components'
import Layout from 'components/Layout'
import Markdown from 'components/Markdown'
import Sidebar from 'components/Sidebar'

import MarkdownContent from './imprint'

const seoTags = {
  title: 'Impressum - Wir sind die Experten für Ihre Immobilie',
  description:
    'Bambus wurde 2018 in Berlin gegründet.',
}

const Page = () => (
  <Layout seo={{ title: seoTags.title, description: seoTags.description }}>
    <Section>
      <Container>
        <Row flexWrap="wrap">
          <Column size={[1, 1, 4 / 12, null]}>
            <Sidebar title="Impressum" />
          </Column>
          <Column size={[1, 1, 8 / 12, null]}>
            <Markdown>
              <MarkdownContent />
            </Markdown>
          </Column>
        </Row>
      </Container>
    </Section>
  </Layout>
)

export default Page
